/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const url = reservationLocalHost + '/settings/specialClosingTime/'

export async function saveSpecialClosingTime (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    deviceId: await getCurrentDeviceId()
  }))
}

export async function deleteSpecialClosingTime (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getSpecialClosingTimes () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}
